module.exports = __webpack_public_path__ + "img/contacto_16-9_960.f2778aa9.webp";